import SelectHoles from './SelectHoles'

export default SelectHoles
